import React, { useState } from 'react';
import { GraduationCap, Play, CheckCircle2 } from 'lucide-react';
import { useTour } from '@/context/TourContext';
import { Button } from '@/components/ui/button';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { Badge } from '@/components/ui/badge';
import { Separator } from '@/components/ui/separator';
import { AnimatedFloatingButton } from '@/components/ui/animated-floating-button';

export const TourFloatingButton: React.FC = () => {
  const { pageTours, startTour, restartTour, isTourCompleted } = useTour();
  const [open, setOpen] = useState(false);

  return (
    <AnimatedFloatingButton
      icon={<GraduationCap className="h-6 w-6" />}
      label="Tutorial"
      gradientFrom="#a955ff"
      gradientTo="#ea51ff"
      onClick={() => setOpen(true)}
      ariaLabel="Abrir tutoriais da página"
    >
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <span className="absolute inset-0 pointer-events-none" />
        </PopoverTrigger>
        <PopoverContent className="w-80" align="end" sideOffset={8}>
        <div className="space-y-4">
          <div className="space-y-2">
            <h4 className="font-semibold text-base flex items-center gap-2">
              <GraduationCap className="h-5 w-5" />
              Tutoriais da Página
            </h4>
            <p className="text-sm text-muted-foreground">
              Tours guiados disponíveis nesta página
            </p>
          </div>

          <Separator />

          <div className="space-y-2">
            {pageTours.map((tour) => {
              const isCompleted = isTourCompleted(tour.id);
              
              return (
                <div
                  key={tour.id}
                  className="flex items-start justify-between gap-2 p-3 rounded-lg border bg-card hover:bg-accent/50 transition-colors"
                >
                  <div className="flex-1 space-y-1">
                    <div className="flex items-center gap-2">
                      <span className="font-medium text-sm">{tour.name}</span>
                      {isCompleted && (
                        <Badge variant="secondary" className="h-5 text-xs">
                          <CheckCircle2 className="h-3 w-3 mr-1" />
                          Completo
                        </Badge>
                      )}
                    </div>
                    {tour.description && (
                      <p className="text-xs text-muted-foreground line-clamp-2">
                        {tour.description}
                      </p>
                    )}
                  </div>
                  
                  <Button
                    size="sm"
                    variant={isCompleted ? "outline" : "default"}
                    onClick={() => {
                      if (isCompleted) {
                        restartTour(tour.id);
                      } else {
                        startTour(tour.id);
                      }
                      setOpen(false);
                    }}
                  >
                    <Play className="h-3 w-3" />
                  </Button>
                </div>
              );
            })}
          </div>
        </div>
      </PopoverContent>
    </Popover>
    </AnimatedFloatingButton>
  );
};
